module.exports = __webpack_public_path__ + "static/img/OSKAR-TAYLOR.0fd16da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/OSKAR-TAYLOR.jpg
// module id = xhT9
// module chunks = 0